export var success = 'Success';
export var error = 'Error';
export var reset = 'Reset';